import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "current-turn-marker"
}
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_player_picture = _resolveComponent("player-picture")!
  const _component_rolled_dice = _resolveComponent("rolled-dice")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["player-header", [`player-header-${_ctx.player.id}`, { 'current-turn': _ctx.isCurrentTurn }]]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchActivePlayer()))
  }, [
    (_ctx.isCurrentTurn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_player_picture, { player: _ctx.player }, null, 8, ["player"]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.player.name), 1),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.availableActions.includes('RollDice'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "header-action-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.rollDice()))
              }, " Tirar dados "))
            : (_ctx.isCurrentTurn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "header-action-button",
                  disabled: !_ctx.availableActions.includes('Pass'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pass()))
                }, " Finalizar turno ", 8, _hoisted_2))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isCurrentTurn && _ctx.diceRoll)
      ? (_openBlock(), _createBlock(_component_rolled_dice, {
          key: 2,
          dice: _ctx.diceRoll
        }, null, 8, ["dice"]))
      : _createCommentVNode("", true)
  ], 2))
}